import LoadingSpinner from '../../uiV2/common/loading/LoadingSpinner'
import Modal from '../Modal'

interface Props {
    onClose: () => void
}

export default function HelixSearchDataLoadingModal({ onClose }: Props) {
    return (
        <Modal
            onClose={onClose}
            title="Loading search results..."
            size="medium"
            allowUserToClose={false}
        >
            <div className="mt-4">
                <LoadingSpinner />
            </div>
        </Modal>
    )
}
